/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/



export default [
  {
    url:"/marcar",
    name: "Marcar",
    slug: "",
    icon: "CalendarIcon",
    tagColor: "success",
    i18n: "SideMenuOption1",
  },
  {
    url:"/marcarOutras",
    name: "MarcarOutras",
    slug: "",
    icon: "CalendarIcon",
    tagColor: "success",
    i18n: "outras_marcacoes",
  },
  {
    url:"/cliente",
    name:"Ficha de Cliente",
    slug: "",
    icon: "UserIcon",
    tagColor: "success",
    i18n: "SideMenuOption2",
  },
  // {
  //   url: "/debito",
  //   name: "Débito ao Quarto",
  //   slug: "",
  //   icon: "HomeIcon",
  //   tagColor: "success",
  //   i18n: "debito_ao_quarto",
  // },
  {
    url: "",
    name: "Relatórios",
    slug: "Relatorios",
    icon: "PieChartIcon",
    i18n: "SideMenuOption6",
    submenu: [
      {
        url: '/relatorio-faturacao',
        name: "Faturação",
        slug: "",
        i18n: "SideMenu6SubOption1",
      },
    ]
  },
  {
    url:"/horarios",
    name: "Horarios",
    slug: "",
    icon: "ClockIcon",
    tagColor: "success",
    i18n: "SideMenuOption5",
    istherapistmanager: true,
    isSpaDirector: true,
    userType: ['7'],
  },
  {
    url:"/clube",
    name: "Clube",
    slug: "",
    icon: "CreditCardIcon",
    tagColor: "success",
    i18n: "clube_vila_gale",
  },
  {
    url: "",
    name: "Configurar",
    slug: "Configurar",
    icon: "SettingsIcon",
    i18n: "SideMenuOption4",
    istherapistmanager: true,
    userType: ['5','7','110'],
    submenu: [
      {
        url: '/spa',
        name: "Spa",
        slug: "",
        i18n: "SideMenu4SubOption1",
        userType: ['5','7','110'],
      },
      {
        url: '/evento',
        name: "Evento",
        slug: "",
        i18n: "SideMenu4SubOption2",
        isSpaDirector: true,
        userType: ['7'],
      },
      {
        url: '/sala',
        name: "Sala",
        slug: "",
        i18n: "SideMenu4SubOption3",
        istherapistmanager: true,
        userType: ['5','7','110']
      },
      {
        name: "Terapeuta",
        slug: "",
        i18n: "SideMenu4SubOption4",       
        submenu: [
          {
            url: '/exploracao',
            name: 'SPA Exploração',
            slug: 'SPA Exploração',
            i18n: 'SPA_exploracao',
            istherapistmanager: true,
            isSpaDirector: true,
            userType: ['7'],
           
          },
          {
            url: '/terapeuta',
            name: 'SPA',
            slug: '',
            i18n: 'SPA',
            userType: ['5','7','110'],
          },
        ]
      },
    ]
  },
];
